'use strict';
var _a;
Object.defineProperty(exports, '__esModule', { value: true });
exports.interfaces = void 0;
exports.interfaces = Object.freeze(
  ((_a = {}),
  (_a['nep141' /* NEP141 */] = {
    id: 'nep141' /* NEP141 */,
    name: 'FT Core (NEP-141)',
    methods: [
      {
        name: 'ft_transfer',
        args: [
          { name: 'receiver_id', type: 'string' },
          { name: 'amount', type: 'string' },
          { name: 'memo', type: ['string', 'null'] },
        ],
      },
      {
        name: 'ft_transfer_call',
        args: [
          { name: 'receiver_id', type: 'string' },
          { name: 'amount', type: 'string' },
          { name: 'memo', type: ['string', 'null'] },
          { name: 'msg', type: 'string' },
        ],
      },
      {
        name: 'ft_total_supply',
        args: [],
      },
      {
        name: 'ft_balance_of',
        args: [{ name: 'account_id', type: 'string' }],
      },
    ],
  }),
  (_a['nep148' /* NEP148 */] = {
    id: 'nep148' /* NEP148 */,
    name: 'FT Metadata (NEP-148)',
    methods: [
      {
        name: 'ft_metadata',
        args: [],
      },
    ],
  }),
  (_a['nep171' /* NEP171 */] = {
    id: 'nep171' /* NEP171 */,
    name: 'NFT Core (NEP-171)',
    methods: [
      {
        name: 'nft_transfer',
        args: [
          { name: 'receiver_id', type: 'string' },
          { name: 'token_id', type: 'string' },
          { name: 'approval_id', type: ['number', 'null'] },
          { name: 'memo', type: ['string', 'null'] },
        ],
      },
      {
        name: 'nft_transfer_call',
        args: [
          { name: 'receiver_id', type: 'string' },
          { name: 'token_id', type: 'string' },
          { name: 'approval_id', type: ['number', 'null'] },
          { name: 'memo', type: ['string', 'null'] },
          { name: 'msg', type: 'string' },
        ],
      },
      {
        name: 'nft_token',
        args: [{ name: 'token_id', type: 'string' }],
      },
    ],
  }),
  (_a['nep177' /* NEP177 */] = {
    id: 'nep177' /* NEP177 */,
    name: 'NFT Metadata (NEP-177)',
    methods: [
      {
        name: 'nft_metadata',
        args: [],
      },
    ],
  }),
  (_a['nep178' /* NEP178 */] = {
    id: 'nep178' /* NEP178 */,
    name: 'NFT Approval Management (NEP-178)',
    methods: [
      {
        name: 'nft_approve',
        args: [
          { name: 'token_id', type: 'string' },
          { name: 'account_id', type: 'string' },
          { name: 'msg', type: ['string', 'null'] },
        ],
      },
      {
        name: 'nft_revoke',
        args: [
          { name: 'token_id', type: 'string' },
          { name: 'account_id', type: 'string' },
        ],
      },
      {
        name: 'nft_revoke_all',
        args: [{ name: 'token_id', type: 'string' }],
      },
      {
        name: 'nft_is_approved',
        args: [
          { name: 'token_id', type: 'string' },
          { name: 'approved_account_id', type: 'string' },
          { name: 'approval_id', type: ['number', 'null'] },
        ],
      },
    ],
  }),
  _a),
);
//# sourceMappingURL=interfaces.js.map
